import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import React, { Suspense, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, Outlet, RouterProvider, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import "./assets/css/Colors.css";
import "./assets/css/Fonts.css";
import "./assets/css/Responsive.css";
import "./assets/css/UtilityClasses.css";
import Loader from "./assets/images/ExplorePage/Loader.svg";
import { speechContainsStopListening, speechContainsWakeWord } from "./components/common/chatWindow/AIUtils";
import ConfirmLeavePage from "./components/common/dialogs/ConfirmLeavePage";
import DefaultErrorPopup from "./components/common/dialogs/DefaultErrorPopup";
import { DefaultNotificationCard } from "./components/common/dialogs/DefaultNotificationCard";
import DeleteAccountPopup from "./components/common/dialogs/DeleteAccountPopup";
import FeedbackAndReturnPopup from "./components/common/dialogs/FeedbackAndReturnPopup";
import FeedbackPopup from "./components/common/dialogs/FeedbackPopup";
import FeedbackSubmittedPopup from "./components/common/dialogs/FeedbackSubmittedPopup";
import InfoPopup from "./components/common/dialogs/InfoPopup";
import NotDeliverByCourier from "./components/common/dialogs/NotDeliverByCourier";
import OrderQRPopup from "./components/common/dialogs/OrderQRPopup";
import OrderSubmitLoader from "./components/common/dialogs/OrderSubmitLoader";
import PaymentsLoader from "./components/common/dialogs/PaymentsLoader";
import QuickBuy from "./components/common/dialogs/QuickBuy/Index";
import ReturnItemPopup from "./components/common/dialogs/ReturnItemPopup";
import ReturnPopup from "./components/common/dialogs/ReturnPopup";
import ReturnSubmittedPopup from "./components/common/dialogs/ReturnSubmittedPopup";
import ShareBOimagePopup from "./components/common/dialogs/ShareBOimagePopup";
import ShipmentAdressPopup from "./components/common/dialogs/ShipmentAdressPopup";
import ShowPolicyDialog from "./components/common/dialogs/ShowPolicyDialog";
import StoreInfoPopup from "./components/common/dialogs/StoreInfoPopup";
import SuggestBrand from "./components/common/dialogs/SuggestBrand";
import SuggestStore from "./components/common/dialogs/SuggestStore";
import ThankYouPopup from "./components/common/dialogs/ThankYouPopup";
import RegistrationLoginForgotPassword from "./components/common/dialogs/UserRegistrationAndLogin/RegistrationLoginForgotPassword";
import ResetPasswordMain from "./components/common/dialogs/UserRegistrationAndLogin/ResetPasswordMain";
import PreLoader from "./components/common/loaders/PreLoader";
import SuccessBlinkComponent from "./components/common/loaders/SuccessBlinkComponent";
import CookiesCondition from "./components/common/mainApp/CookiesCondition";
import Footer from "./components/common/mainApp/Footer";
import Header from "./components/common/mainApp/Header";
import RightPanelDrawerSwitcher from "./components/common/mainApp/RightPanelDrawerSwitcher";
import NoInternetMarker from "./components/common/NoInternetMarker";
import FullScreenOverlay from "./components/common/overlay/FullScreenOverlay";
import TakePhoto from "./components/common/TakePhoto";
import BOTagLightBox from "./components/pages/BOImage/BOTagComponents/BOTagLightBox";
import BOTagRedirectPage from "./components/pages/BOTagRedirectPage";
import Homepage from "./components/pages/Homepage/Homepage";
import AppContext from "./contexts/AppContext";
import LayoutContext from "./contexts/LayoutContext";
import StandardsContext from "./contexts/StandardsContext";
import UserContext from "./contexts/UserContext";
import { AllRoutes } from "./routes/AllRoutes";
import * as Library from "./utils/Library";

const checkFacebookPhotosInterval = 10000; // 10 seconds

export default function App() {
    const ErrorBoundaryLayout = () => {
        return (
            <ErrorBoundary
                FallbackComponent={Homepage}
                onError={error => {
                    //window.location.href = "/";
                    console.log("Error in the app", error);
                }}>
                <RouterLayoutTemplate />
            </ErrorBoundary>
        );
    };
    const router = createBrowserRouter([{ element: <ErrorBoundaryLayout />, children: AllRoutes }]);
    return <RouterProvider router={router} />;
}

/* #region SMALL COMPONENTS */
function RouterLayoutTemplate() {
    /* #region VARS */
    const navigate = useNavigate();
    const location = useLocation();
    const passwordToken = new URLSearchParams(location.search).get("passwordToken");
    const { appPasswordActive, appPasswordValidated, isLoadingApp } = React.useContext(AppContext);
    const {
        showHeader,
        showFooter,
        showPolicyPopup,
        showShippingAddressPopup,
        showBOImagePageID,
        isMobile,
        showAccountDeletePopup,
        showUserLoginRegisterPopup,
        showConfirmBox,
        showAccountUnsavedPopup,
        showThankYouPopup,
        showShareBOimagePopup,
        showStoreInformation,
        showReturnAndFeedBackPopup,
        showFeedbackPopup,
        showReturnPopup,
        showReturnItemPopup,
        showFeedbackSubmittedPopup,
        showReturnSubmittedPopup,
        placeOrderLoading,
        showQrPopup,
        showProductGalleryLightbox,
        showSuggestPopup,
        showSuggestStorePopup,
        quickBuyPopup,
        notDeliverCourier,
        showInfoPopup,
        showCheckoutSuccessBlink,
        isCardPayment,
        onFocusSearchBox,
        paymentLoading,
        setShowRightAiPanel,
        showTakePhotoPopup,
        setAIPanelNewFacebookPhoto
    } = React.useContext(LayoutContext);
    const { checkoutCartData } = React.useContext(UserContext);

    const locationClass = showBOImagePageID ? "boImagePage" : location.pathname.split("/")[1] + "Page";
    const [pageNeedsRedirect, setPageNeedsRedirect] = React.useState(false);

    const recognizerRef = React.useRef(null);
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        if (!appPasswordActive) return;
        if (appPasswordValidated) return;

        const currentUrl = window.location.href;
        const redirectUrl = new URLSearchParams(location.search).get("redirectURL");

        if (!localStorage.getItem("BOTagCode")) {
            if (location.pathname !== "/password" && !redirectUrl) {
                navigate(`/password?redirectURL=${encodeURIComponent(currentUrl)}`);
            } else if (!redirectUrl) {
                navigate("/password");
            } else {
                navigate(`/password?redirectURL=${redirectUrl}`);
            }
            return;
        }

        if (location.pathname === "/password" && appPasswordValidated) {
            navigate("/explore");
            return;
        }
    }, [appPasswordActive, location.pathname, localStorage.getItem("BOTagCode")]); // first time loading check for password

    /* useEffect(() => {
        //setTimeout 60min
        const timer = setTimeout(() => {
            //TODO: Check if password is valid
            //TODO: Add fullscreen loader while checking
        }, 3600000);

        return () => {
            clearTimeout(timer);
        };
    }, []); */

    useEffect(() => {
        const domain = window.location.hostname;
        if (domain.includes("botag.no")) setPageNeedsRedirect(true);
        //if (domain.includes("localhost")) setPageNeedsRedirect(true);
    }, []); // if domain is botag.no and needs redirection

    useEffect(() => {
        // It is needed an user gesture to start AudioContext because of the following error:
        // "The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page."
        function handleFirstClick(e) {
            // return;
            startVoiceInput();
            // Remove the event listener after first interaction
            document.removeEventListener("click", handleFirstClick);
        }
        document.addEventListener("click", handleFirstClick);

        // Cleanup in case component unmounts before click
        return () => {
            document.removeEventListener("click", handleFirstClick);
            stopVoiceInput();
        };
    }, []); // Start voice input on first user interaction

    useEffect(() => {
        const checkNewFacebookPhotos = async () => {
            if (Library.isLocalhost("checkNewFacebookPhotos", true)) return;

            const res = await Library.makePostRequest("getFacebookPhotos");
            if (res?.data?.status !== 200) return false;
            const data = res?.data?.data;

            if (!data?.latestPhoto) return;

            console.log("New Meta Rayban display photo: ", data?.latestPhoto);
            setAIPanelNewFacebookPhoto(data?.latestPhoto);

            // check if ai right panel is open, if not open it
            setShowRightAiPanel(true);
        };
        const interval = setInterval(checkNewFacebookPhotos, checkFacebookPhotosInterval);

        return () => clearInterval(interval);
    }, []); // Check if there are new facebook photos every 10 seconds
    /* #endregion */

    /* #region METHODS */
    const startVoiceInput = () => {
        // If is localhost do not start voice input
        if (Library.isLocalhost("startVoiceInput", true)) return;

        // Stop any existing recognizer before starting a new one
        /* if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                recognizerRef.current.close();
                recognizerRef.current = null;
            });
        } */

        const azureKey = process.env.REACT_APP_AZURE_AI_SPEECH_KEY;
        const azureRegion = process.env.REACT_APP_AZURE_AI_SPEECH_REGION;

        const speechConfig = SpeechSDK.SpeechConfig.fromSubscription(azureKey, azureRegion);
        speechConfig.speechRecognitionLanguage = "en-US";
        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
        const recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);

        recognizer.recognizing = recognizingBeforeWakeWord;
        recognizer.recognized = recognizedBeforeWakeWord;

        recognizer.canceled = (s, e) => {
            const errorCode = e.privErrorCode;
            const errorDetails = e.privErrorDetails;

            console.log(`SPEECH CANCELED: Error=${errorCode}, ${errorDetails}`);
        };

        recognizer.sessionStopped = (s, e) => {
            const reason = e?.reason || e?.privReason || e?.privErrorDetails || "Unknown";
            console.log(`SESSION STOPPED: Reason=${reason}`);
        };

        recognizer.startContinuousRecognitionAsync();
        recognizerRef.current = recognizer;
    };

    const recognizingBeforeWakeWord = (s, e) => {
        console.log(`RECOGNIZING Main: ${e.result.text}`);
    };

    const recognizedBeforeWakeWord = (s, e) => {
        if (e.result.reason !== SpeechSDK.ResultReason.RecognizedSpeech) return;
        const resultText = e.result.text;

        // check if the recognized text contains "stop listening"
        if (speechContainsStopListening(resultText)) {
            stopVoiceInput();
            return;
        }

        // Only start recognizing if not already recognizing
        if (speechContainsWakeWord(resultText)) {
            stopVoiceInput();
            setShowRightAiPanel(true);
            return;
        }
    };

    const stopVoiceInput = () => {
        if (recognizerRef.current) {
            recognizerRef.current.stopContinuousRecognitionAsync(() => {
                recognizerRef.current.close();
                recognizerRef.current = null;
                console.log("Recognition stopped.");
            });
        }
    };
    /* #endregion */

    return (
        <div className="wrapper">
            <NoInternetMarker />
            <ToastContainer />
            <DefaultNotificationCard />

            <FullScreenOverlay show={isLoadingApp}>
                <div className="loading-skeleton">
                    <img src={Loader} alt="" className="spinner-img" style={{ animation: "spin 1s linear infinite" }} />
                    <div style={{ fontSize: "16px", fontWeight: 600, color: "rgba(255, 255, 255, 1)" }}>Loading please wait...</div>
                </div>
            </FullScreenOverlay>

            {pageNeedsRedirect ? (
                <BOTagRedirectPage />
            ) : (
                <Suspense
                    fallback={
                        <div>
                            <PreLoader />
                        </div>
                    }>
                    {showTakePhotoPopup && <TakePhoto />}
                    {showThankYouPopup && <ThankYouPopup checkoutCartData={checkoutCartData} />}
                    {showShareBOimagePopup && <ShareBOimagePopup />}
                    {showReturnAndFeedBackPopup && <FeedbackAndReturnPopup />}
                    {showFeedbackPopup && <FeedbackPopup />}
                    {showReturnPopup && <ReturnPopup />}
                    {showReturnItemPopup && <ReturnItemPopup />}
                    {showFeedbackSubmittedPopup && <FeedbackSubmittedPopup />}
                    {showReturnSubmittedPopup && <ReturnSubmittedPopup />}

                    <div className={`mainWrapper ${locationClass} ${isMobile ? "mobile" : "desktop"}`}>
                        <ErrorDialog />

                        <div className="leftSide">
                            {showHeader && <Header className="mainHeader" />}
                            <div className={`mainContent ${onFocusSearchBox ? "bg-blur" : ""}`} id="mainContent">
                                <Outlet /> {/* ROUTES WILL RENDER HERE IN THIS OUTLET */}
                            </div>
                            <CookiesCondition />
                            {showFooter && <Footer className="mainFooter" />}

                            {showProductGalleryLightbox?.isOpen && !isMobile && <BOTagLightBox />}
                        </div>

                        <RightPanelDrawerSwitcher />
                    </div>

                    {/* POPUPS */}
                    {showShippingAddressPopup && <ShipmentAdressPopup />}
                    {showPolicyPopup && <ShowPolicyDialog />}
                    {showUserLoginRegisterPopup && <RegistrationLoginForgotPassword />}
                    {showAccountDeletePopup && <DeleteAccountPopup />}
                    {showConfirmBox && <ConfirmLeavePage />}
                    {showAccountUnsavedPopup && <ConfirmLeavePage />}
                    {passwordToken && <ResetPasswordMain />}
                    {showStoreInformation && <StoreInfoPopup />}
                    {placeOrderLoading && <OrderSubmitLoader />}
                    {paymentLoading && <PaymentsLoader />}
                    {!isCardPayment && showCheckoutSuccessBlink && <SuccessBlinkComponent />}
                    {showQrPopup && <OrderQRPopup />}
                    {showSuggestPopup && <SuggestBrand />}
                    {showSuggestStorePopup && <SuggestStore />}
                    {showProductGalleryLightbox?.isOpen && isMobile && <BOTagLightBox />}
                    {quickBuyPopup && <QuickBuy />}
                    {notDeliverCourier && <NotDeliverByCourier />}
                    {showInfoPopup.state && <InfoPopup />}
                </Suspense>
            )}
        </div>
    );
}

//TODO: REVIEW THIS COMPONENT TO BE MORE INTUITIVE
function ErrorDialog() {
    const {
        errorDialogShow,
        setErrorDialogShow,
        errorDialogTitle,
        setErrorDialogTitle,
        errorDialogMessage,
        setErrorDialogMessage,
        errorDialogConfirmText,
        errorDialogCancelText,
        setErrorDialogAction
    } = React.useContext(StandardsContext);

    return errorDialogShow ? (
        <div>
            <DefaultErrorPopup
                title={errorDialogTitle}
                message={errorDialogMessage}
                confirmBtnText={errorDialogConfirmText}
                cancelBtnText={errorDialogCancelText}
                cancelBtnAction={() => {
                    setErrorDialogShow(false);
                    setErrorDialogTitle("");
                    setErrorDialogMessage("");
                    setErrorDialogAction("cancel");
                }}
                confirmBtnAction={() => {
                    setErrorDialogShow(false);
                    setErrorDialogTitle("");
                    setErrorDialogMessage("");
                    setErrorDialogAction("confirm");
                }}
            />
        </div>
    ) : null;
}
/* #endregion */
